import { FC, useState } from "react";
import { Select, Space, Tag, Typography } from "antd";

import { TV_LEAGUES, TvMatchRef, tvLeagueTitle } from "../Lib";
import { MatchPicker, matchLabel } from "./MatchPicker";

const key = (m: TvMatchRef) => `${m.leagueId}:${m.matchId}`;

type Props = {
  value?: TvMatchRef[];
  onChange?: (value: TvMatchRef[]) => void;
};

/** Матчи спецпроекта: список с удалением и поиск матча по лиге. На сайте — в ленте с выпусками по дате. */
export const MatchesEditor: FC<Props> = ({ value = [], onChange }) => {
  const [leagueId, setLeagueId] = useState<number>(TV_LEAGUES[0].value);

  const add = (match?: TvMatchRef) => {
    if (!match || value.some((m) => key(m) === key(match))) return;
    onChange?.([...value, match]);
  };

  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      {value.length === 0 ? (
        <Typography.Text type="secondary">Матчей нет</Typography.Text>
      ) : (
        <Space direction="vertical" size={4}>
          {value.map((m) => (
            <Tag
              key={key(m)}
              closable
              style={{ whiteSpace: "normal" }}
              onClose={(e) => {
                e.preventDefault();
                onChange?.(value.filter((x) => key(x) !== key(m)));
              }}
            >
              {tvLeagueTitle(m.leagueId)}: {matchLabel(m)}
            </Tag>
          ))}
        </Space>
      )}
      <Space.Compact style={{ width: "100%" }}>
        <Select
          style={{ width: 220 }}
          options={TV_LEAGUES}
          value={leagueId}
          onChange={setLeagueId}
        />
        <MatchPicker
          leagueId={leagueId}
          value={null}
          onChange={(_, match) => add(match)}
        />
      </Space.Compact>
    </Space>
  );
};
